import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-home',
  standalone: true,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateMeta(
      'Qaryos — Rondes de sécurité simples et fiables',
      'Centralisez et suivez toutes vos rondes de sécurité avec Qaryos : application mobile pour planifier, tracer et prouver vos inspections en toute simplicité.'
    );
  }
}
